<template>
  <div class="text-view-container">
    <div class="wrapper-card bg-default d-flex flex-column">
      <div class="header-wrapper">
        <header
          v-if="showHeader"
          class="d-flex flex-wrap-1 align-center px-2"
        >
          <div class="d-flex align-center">
            <span
              class="text-uppercase ml-2 user-name"
              :class="isFullScreen ? 'text-h4' : 'text-h6'"
              :style="headerStyle"
            >
              {{ headerText }}<template v-if="complemento"> - {{ complemento }}</template>
            </span>
          </div>
        </header>
      </div>
      <div
        v-html="text"
        class="px-3 py-3 font-weight-normal text-content bg-secondary d-flex align-center"
        :style="textStyle"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextView',
  props: {
    headerText: {
      type: String,
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    complemento: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textStyle: {
      type: Object,
      default: () => ({}),
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    headerStyle() {
      return this.isFullScreen
        ? 'font-size: 1.5rem; font-weight: 500; text-transform: none !important;'
        : 'font-size: 1rem; font-weight: 500; text-transform: none !important;';
    },
    backgroundColor() {
      return this.colors.backgroundColor || '#ED4619';
    },
    backgroundColorEnd() {
      return this.colors.backgroundColorEnd || '#2C172C';
    },
    backgroundGradient() {
      return `linear-gradient(to bottom, ${this.backgroundColor}, ${this.backgroundColorEnd})`;
    },
    secondaryColor() {
      return this.colors.secondaryColor || '#DDDCDC';
    },
    textColor() {
      return this.colors.textColor || '#4C1D23';
    },
  },
};
</script>

<style lang="scss" scoped>
.text-view-container {
  width: 100%;
  height: 100%;
}

.wrapper-card {
  width: 100%;
  height: 100%;
  padding: 5px;
  border-radius: 10px 10px 0 0;
  box-shadow: inset 0 40px 10px -25px v-bind(backgroundColor);
  overflow: hidden;
}

.header-wrapper {
  width: 100%;
  border-radius: 10px 10px 0 0;
}

.bg-default {
  background: v-bind(backgroundGradient);
}

.bg-secondary {
  background-color: v-bind(secondaryColor);
}

.user-name {
  text-transform: none !important;
  font-family: 'ZuumeEdge', sans-serif !important;
  font-style: italic !important;
  font-weight: bold !important;
  text-shadow: 0 1.5px 0 rgba(0, 0, 0, 0.3);
  color: v-bind(secondaryColor);
}

.text-content {
  color: v-bind(textColor);
  font-family: 'Globotipo', sans-serif;
  font-style: normal;
  font-weight: bold;
  word-break: break-word;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

header {
  width: 100%;
  background-color: transparent;
}
</style>
